import "./styles.scss";

import { useState } from "react";

const CollabStatusBar = ({ initialRole = "teacher", initialStatus = "disconnected" }) => {
  const [status, setStatus] = useState(initialStatus);

  const handleConnect = () => setStatus("connected");
  const handleDisconnect = () => setStatus("disconnected");

  return (
    <div className="collabStatusBar">
      <span className="collabStatusBar__brand">collabLib POC</span>
      <span>
        Role: <strong>{initialRole}</strong>
      </span>
      <span>
        WS: <strong>{status}</strong>
      </span>
      <button type="button" className="collabStatusBar__btn collabStatusBar__btn--primary" onClick={handleConnect}>
        Connect
      </button>
      <button type="button" className="collabStatusBar__btn collabStatusBar__btn--ghost" onClick={handleDisconnect}>
        Disconnect
      </button>
    </div>
  );
};

export default CollabStatusBar;
